import { call, take, takeEvery } from 'redux-saga/effects';

import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';
import { transformResponseToRules, transformRuleToRequestData } from './transformers';


// ===============================================================================================
// SAGAS functions for rules.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'rule',
  resourceBaseUrl: '/rename-rules',
  getLastSyncDate,

  transformResponseToResources: transformResponseToRules,
  transformResourceToRequestData: transformRuleToRequestData,

  successAction,
  failureAction,
});

export function* getRulesActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  while (true) {
    const action = yield take(actions.getRules);

    const config = mkResourceConfig(actions.getRulesSuccess, actions.getRulesFailure);
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createRuleActionWatcher() {
  const config = mkResourceConfig(actions.createRuleSuccess, actions.createRuleFailure);
  yield takeEvery(actions.createRule, qcsSyncCreateResource, config);
}

export function* updateRuleActionWatcher() {
  const config = mkResourceConfig(actions.updateRuleSuccess, actions.updateRuleFailure);
  yield takeEvery(actions.updateRule, qcsSyncUpdateResource, config);
}

export function* deleteRuleActionWatcher() {
  const config = mkResourceConfig(actions.deleteRuleSuccess, actions.deleteRuleFailure);
  yield takeEvery(actions.deleteRule, qcsSyncDeleteResource, config);
}


// ====================================================
// EXPORTS

export default [
  getRulesActionWatcher,
  createRuleActionWatcher,
  updateRuleActionWatcher,
  deleteRuleActionWatcher,
];
